import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/StoreContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { SoundProvider } from "@/context/SoundContext";
import { AuthProvider } from "@/context/AuthContext";

import StorefrontLayout from "@/components/storefront/StorefrontLayout";
import Home from "@/pages/Home";
import CollectionPage from "@/pages/CollectionPage";
import ProductPage from "@/pages/ProductPage";
import JournalPage from "@/pages/JournalPage";
import ArticlePage from "@/pages/ArticlePage";
import StaticPage from "@/pages/StaticPage";
import ReturnRequest from "@/pages/ReturnRequest";
import SavedPage from "@/pages/SavedPage";
import SearchPage from "@/pages/SearchPage";
import NotFound from "@/pages/NotFound";
import CheckoutPage from "@/pages/CheckoutPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AccountPage from "@/pages/AccountPage";
import GiftCardPage from "@/pages/GiftCardPage";
import FaqPage from "@/pages/FaqPage";
import OriWorld from "@/pages/OriWorld";
import LookbookPage from "@/pages/LookbookPage";
import LookbookDetail from "@/pages/LookbookDetail";

import CraftsLayout from "@/components/crafts/CraftsLayout";
import CraftsHome from "@/pages/crafts/CraftsHome";
import CraftPage from "@/pages/crafts/CraftPage";
import CraftsSuccess from "@/pages/crafts/CraftsSuccess";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Overview from "@/admin/Overview";
import ProductsAdmin from "@/admin/ProductsAdmin";
import ProductEditor from "@/admin/ProductEditor";
import CollectionsAdmin from "@/admin/CollectionsAdmin";
import HomepageAdmin from "@/admin/HomepageAdmin";
import SettingsAdmin from "@/admin/SettingsAdmin";
import SoundAdmin from "@/admin/SoundAdmin";
import JournalAdmin from "@/admin/JournalAdmin";
import PagesAdmin from "@/admin/PagesAdmin";
import ListsAdmin from "@/admin/ListsAdmin";
import OrdersAdmin from "@/admin/OrdersAdmin";
import ReturnsAdmin from "@/admin/ReturnsAdmin";
import DiscountsAdmin from "@/admin/DiscountsAdmin";
import GiftCardsAdmin from "@/admin/GiftCardsAdmin";
import IntegrationsAdmin from "@/admin/IntegrationsAdmin";
import MailAdmin from "@/admin/MailAdmin";
import NewsletterAdmin from "@/admin/NewsletterAdmin";
import FaqAdmin from "@/admin/FaqAdmin";
import DropLaunch from "@/admin/DropLaunch";
import LaunchAdmin from "@/admin/LaunchAdmin";
import LookbookAdmin from "@/admin/LookbookAdmin";
import CraftsAdmin from "@/admin/CraftsAdmin";
import CraftEditor from "@/admin/CraftEditor";

function App() {
  return (
    <AuthProvider>
      <StoreProvider>
        <CurrencyProvider>
        <SoundProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<StorefrontLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/collections/:slug" element={<CollectionPage />} />
                <Route path="/products/:slug" element={<ProductPage />} />
                <Route path="/journal" element={<JournalPage />} />
                <Route path="/journal/:slug" element={<ArticlePage />} />
                <Route path="/pages/:slug" element={<StaticPage />} />
                <Route path="/returns/start" element={<ReturnRequest />} />
                <Route path="/saved" element={<SavedPage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/gift-cards" element={<GiftCardPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/the-ori-world" element={<OriWorld />} />
                <Route path="/lookbook" element={<LookbookPage />} />
                <Route path="/lookbook/:slug" element={<LookbookDetail />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route element={<CraftsLayout />}>
                <Route path="/crafts" element={<CraftsHome />} />
                <Route path="/crafts/success" element={<CraftsSuccess />} />
                <Route path="/crafts/:slug" element={<CraftPage />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Overview />} />
                <Route path="orders" element={<OrdersAdmin />} />
                <Route path="returns" element={<ReturnsAdmin />} />
                <Route path="products" element={<ProductsAdmin />} />
                <Route path="products/:id" element={<ProductEditor />} />
                <Route path="collections" element={<CollectionsAdmin />} />
                <Route path="discounts" element={<DiscountsAdmin />} />
                <Route path="gift-cards" element={<GiftCardsAdmin />} />
                <Route path="mail" element={<MailAdmin />} />
                <Route path="newsletter" element={<NewsletterAdmin />} />
                <Route path="integrations" element={<IntegrationsAdmin />} />
                <Route path="homepage" element={<HomepageAdmin />} />
                <Route path="settings" element={<SettingsAdmin />} />
                <Route path="sound" element={<SoundAdmin />} />
                <Route path="journal" element={<JournalAdmin />} />
                <Route path="lookbook" element={<LookbookAdmin />} />
                <Route path="pages" element={<PagesAdmin />} />
                <Route path="faq" element={<FaqAdmin />} />
                <Route path="drop" element={<DropLaunch />} />
                <Route path="launch" element={<LaunchAdmin />} />
                <Route path="crafts" element={<CraftsAdmin />} />
                <Route path="crafts/:id" element={<CraftEditor />} />
                <Route path="lists" element={<ListsAdmin />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-center" />
        </SoundProvider>
        </CurrencyProvider>
      </StoreProvider>
    </AuthProvider>
  );
}

export default App;
